// extracted by mini-css-extract-plugin
export default {"modalHeader":"MoreInfoModal_modalHeader__Qd-7L","cardContent":"MoreInfoModal_cardContent__UCWj4"};